import React, { createContext, useContext } from 'react';

function randomId() {
  return `mantine-${Math.random().toString(36).substr(2, 9)}`;
}
const UuidContext = createContext(() => randomId());
const useUuid = (staticId) => {
  const generateId = useContext(UuidContext);
  return staticId || generateId();
};
function SsrProvider({ children }) {
  let id = 0;
  const generateId = () => {
    id += 1;
    return `mantine-${id}`;
  };
  return /* @__PURE__ */ React.createElement(UuidContext.Provider, {
    value: generateId
  }, children);
}

export { SsrProvider, useUuid };
//# sourceMappingURL=SsrProvider.js.map
